import React from 'react';
import './courseProvided.css'
import C2wCourseProvideCard from '../../../../common/C2wHome/courseDetails/courseProvideCard';

function C2wCourseProvided( { courseData=null} ) {
  /**
 * @constant renderCards
 * @author Vishal Lohbande
 * @description Maps over the `provideContent` array inside `courseData` to render
 * a list of `C2wCourseProvideCard` components. Each card receives the corresponding
 * content object (`obj`) and its index as props.
 * 
 * @returns {JSX.Element[]} Array of `C2wCourseProvideCard` components
 * 
 * Usage:
 * Used to display the various provisions or features offered in the course.
 */
  const renderCards = courseData?.provideContent?.map((obj,index) => {
    return <C2wCourseProvideCard  obj={obj} index={index} />

  })
  return (
    <div className='C2wCourseProvided_ctn'>
      <div className='C2wCoureseDetailComponentHeading_ctn'>
        <div className='heading'>
          {`${'What Do '} `}
          <span className='headingSpan'>{`${'We Provide?'}`}</span>
        </div>
        <div className='headingDesc'>
          {courseData?.couseProvidedSubTitle}
        </div>
      </div>
      <div className='C2wCourseProvided_card_ctn'>
         {renderCards}
      </div>
    </div>
  )
}

export default C2wCourseProvided